import { render, staticRenderFns } from "./CompanyEditGeneralDetails.vue?vue&type=template&id=8a83e146&"
import script from "./CompanyEditGeneralDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyEditGeneralDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports